import React from 'react'

const SkeletonBlock = ({ width, height = 14, borderRadius = 4 }) => (
  <div className="skeleton-block" style={{ width, height, borderRadius }} />
)

// Loading placeholder shown by TopComponents while the compliance form's props
// are still being fetched. This is intentionally specific to the compliance form
// (the only requirements_page.top_components contributor today) rather than a
// generic placeholder — a future second plugin should ship its own skeleton.
export default function ComplianceFormSkeleton() {
  return (
    <div
      className="requirements-top-components-skeleton dome-light-shadow dome-bg-white dome-rounded-border dome-d-flex dome-flex-column dome-gap6"
      style={{ padding: 18, marginBottom: 30 }}
    >
      <div className="dome-d-flex dome-align-center dome-justify-between">
        <div className="dome-h4">nyc law compliance form</div>
        <SkeletonBlock width={120} height={22} borderRadius={20} />
      </div>
      <SkeletonBlock width="70%" />
    </div>
  )
}
